var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2077 9.16671C15.2077 12.5 9.99935 16.0417 9.99935 16.0417C9.99935 16.0417 4.79102 12.5 4.79102 9.16671C4.79102 6.25004 7.23792 3.95837 9.99935 3.95837C12.7608 3.95837 15.2077 6.25004 15.2077 9.16671Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.0416C11.0355 11.0416 11.875 10.2022 11.875 9.16663C11.875 8.13109 11.0355 7.29163 10 7.29163C8.96447 7.29163 8.125 8.13109 8.125 9.16663C8.125 10.2022 8.96447 11.0416 10 11.0416Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.af8036831e3a35e4a3de426d908646ad.svg";
export { ForwardRef as ReactComponent };